import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * `/configuration/manager` is the container for the Parameters and Audit Trail
 * tabs — redirect to Parameters as the default landing tab so the URL is always
 * explicit about which tab is active. Search params (e.g. `platform`) are
 * preserved across the hop.
 */
export const Route = createFileRoute('/_authenticated/_tenant/configuration/manager/')({
  beforeLoad: ({ search }) => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- TanStack Router requires throwing a redirect
    throw redirect({ to: '/configuration/manager/parameters', search });
  },
});
